import { createContext, useContext, useState } from 'react'

interface ILoadingContextData {
  isLoading: boolean
  setIsLoading(isLoading: boolean): void
}

const LoadingContext = createContext({} as ILoadingContextData)

const LoadingProvider: React.FC<any> = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </LoadingContext.Provider>
  )
}

function useLoading() {
  const context = useContext(LoadingContext)

  if (!context) {
    throw new Error('useLoading must be used within an LoadingProvider')
  }

  return context
}

export { LoadingProvider, useLoading }
